export const userData = {
    accountId: null,
    email: null,
    lastName: null,
    firstName: null,
    token: null,
    role: null,
    endTour: true,
};